'use client';

import { HouseholdSwitcher } from './HouseholdSwitcher';
import { useHouseholdSwitcher } from './use-household-switcher';

export { switchActiveHouseholdMutationOptions } from './use-household-switcher';

export function HouseholdSwitcherContainer() {
  const { ready, activeHouseholdId, memberHouseholds, onSelect, switching } = useHouseholdSwitcher();

  if (!ready) {
    return null;
  }

  return (
    <HouseholdSwitcher
      activeHouseholdId={activeHouseholdId}
      memberHouseholds={memberHouseholds}
      onSelect={onSelect}
      disabled={switching}
    />
  );
}
